/* global ParamsData */
import Popin from './popin';

export default contestsPopin => {
    const dataPopin = contestsPopin.getAttribute('data-popin');
    const popin = document.querySelector(`#${dataPopin}`);
    const popinBox = popin.querySelector('.popin-box');
    const popinContent = popin.querySelector('.content');

    function getContent(contest) {
        let html = '';

        html += `
            <div class="left-part">
                <div class="img-container">
                    <img src="${contest.image.url}" alt="${contest.image.alt}">
                </div>
                <div class="btns-container">
        `;

        if (`${contest.cta.type}` === 'link') {
            html += `
                    <a href="${contest.cta.url}" class="cta-btn plain primary" target="_blank">${contest.cta.text}</a>
            `;
        }

        if (`${contest.cta.type}` === 'button') {
            html += `
                    <button type="button" class="cta-btn plain primary" disabled>${contest.cta.text}</button>
            `;
        }

        // if (`${contest.cta.type}` === 'disabled') {
        //     html += `
        //             <button type="button" class="cta-btn plain primary" disabled>${contest.cta.text}</button>
        //     `;
        // }

        html += `
                </div>
            </div>

            <div class="right-part">
                <div class="text-container">
                    <div class="contest-date"><strong>${contest.date}</strong></div>
                    <div class="contest-title">${contest.title}</div>

                    <ul class="contest-infos">`;
        if (`${contest.type_label}` != '') {
            html += `<li class="contest-info"><strong>${contest.type_generic_label} :</strong> <span class="${contest.type}">${contest.type_label}</span></li>`;
        }
        if (`${contest.game_type_label}` != '') {
            html += `<li class="contest-info"><strong>${contest.game_type_generic_label} :</strong> ${contest.game_type_label}</li>`;
        }
        html += `</ul>

                    <hr>

                    ${contest.text}
                </div>
            </div>
        `;

        popinBox.classList.remove('loading');
        popinContent.innerHTML = html;
    }

    function removeContent() {
        popinContent.innerHTML = '';
    }

    function sendAjax(id, siteid) {
        const request = new XMLHttpRequest();
        const url = ParamsData.wp_ajax_url;
        const ajaxData = new FormData();

        ajaxData.append('action', popin.getAttribute('data-action'));
        ajaxData.append('nonce', popin.getAttribute('data-nonce'));
        ajaxData.append('id', id);
        ajaxData.append('siteid', siteid);

        request.open('POST', url, true);

        request.send(ajaxData);

        request.onprogress = () => {
            //console.log('onprogress...');
        };

        request.onload = () => {
            let response = request.response;

            if (typeof response === 'string') {
                response = JSON.parse(response);
            }

            getContent(response.json_contest);
        };

        request.onerror = () => {
            //console.log('onerror...');
        };
    }

    contestsPopin.addEventListener('click', event => {

        const dataContestId = event.target.getAttribute('data-contest-id');
        const dataSiteId = event.target.getAttribute('data-siteid');

        Popin({
            id: contestsPopin.getAttribute('data-popin'),
            beforeOpen() {
                //sendAjax(dataContestId, dataSiteId);
                popinBox.classList.remove('loading');
                popinContent.innerHTML = contestsPopin.closest('.card-contest').querySelectorAll('.box-content')[0].innerHTML;
            },
            afterClose() {
                removeContent();
                popinBox.classList.add('loading');
            },
        });
    });
};
